import { DimensionsType } from "@/components/ui-v2/AspectRatio/types";
import { ReferenceImageType } from "@/components/ui-v2/References/types";
import { JSONObject } from "@/types";

import { Maybe } from "../../../graphql/schema.graphql";
import { NO_TRANSLATION_PROMPT_LANGUAGE } from "../../constants";
import {
  STYLE_COMPONENTS_FIELD_NAME,
  STYLE_FIELD_NAME,
} from "../../fields/Style/constants";
import type { FormWithStyle } from "../../fields/Style/types";
import { DEFAULT_FIELDS_STYLE } from "../../fields/Style/utils";

export const MAX_EDIT_IMAGE_DIMENSION = 4096;

export const FORM_FIELDS_PROMPT_EDIT_IMAGE = {
  STYLE: STYLE_FIELD_NAME,
  STYLE_COMPONENTS: STYLE_COMPONENTS_FIELD_NAME,
  PROMPT_LANGUAGE: "promptLanguage",
  PROMPT_TEXT: "promptText",
  PROMPT_JSON: "promptJson",
  REFERENCES: "references",
  DIMENSIONS: "dimensions",
} as const;

export interface FormTypePromptEditImage extends FormWithStyle {
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.PROMPT_LANGUAGE]: string;
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.PROMPT_TEXT]: string;
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.PROMPT_JSON]: Maybe<JSONObject>;
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.REFERENCES]: ReferenceImageType[];
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.DIMENSIONS]: DimensionsType;
}

export const DEFAULT_PROMPT_EDIT_IMAGE_FORM_VALUES: FormTypePromptEditImage = {
  ...DEFAULT_FIELDS_STYLE,
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.PROMPT_LANGUAGE]:
    NO_TRANSLATION_PROMPT_LANGUAGE,
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.PROMPT_TEXT]: "",
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.PROMPT_JSON]: null,
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.REFERENCES]: [],
  [FORM_FIELDS_PROMPT_EDIT_IMAGE.DIMENSIONS]: [1024, 1024],
};
